module.exports = __webpack_public_path__ + "static/OCRB-f273d480bb4d15b473f2959825f1dcfb.woff";